import { CircularProgress } from "@mui/material";
import { CloudSync } from "@mui/icons-material";
import restoreMails from "../../../Actions/restoreMails";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import IconButton from "../../../../UI/GeneralPurpose/IconButton";
import { useWorker } from "../../../../../Hooks/useWorker";

const UIText = { universal: {} };

const Restore = ({ id }) => {
  const { auth, dispatch, settings } = useUIBp();
  const { working } = useWorker("restore-" + id);

  const onClick = (e) => {
    e.stopPropagation();
    dispatch(
      restoreMails({
        ...auth,
        workerId: "restore-" + id,
        mailIDs: [id],
        locale: settings.locale,
      })
    );
  };

  const icon = working ? (
    <CircularProgress size={20} />
  ) : (
    <CloudSync sx={{ fontSize: 20 }} />
  );

  return (
    <IconButton
      {...{
        disabled: working,
        UIText,
        onClick,
        icon,
        sx:{
          '&:hover':{
            color:'primary.main'
          }
        }
      }}
    />
  );
};

export default Restore;
